import Box from "@mui/material/Box";
import { Suspense } from "react";
import { Outlet, useParams } from "react-router";
import { Footer } from "@/components/layout/Footer";
import { Header } from "@/components/layout/Header";
import { RouteFallback } from "@/components/layout/RouteFallback";
import { setCaseToken } from "@/lib/caseToken";
import { colors } from "@/theme/colors";

// ゲストアプリのアプリシェル。Header + コンテンツ + Footer の縦並び構成。
// モバイルファーストのレスポンシブデザイン (SP: xs, Tablet: sm, PC: md 以上)。
export function AppLayout() {
  // URL の案件アクセストークン (/{caseToken}/...) を RPC interceptor へ渡すため、
  // 表示中ページの caseToken を都度反映する (ADR-011)。
  const { caseToken } = useParams<{ caseToken: string }>();
  // レンダー直後に子コンポーネントの useQuery が発火しても interceptor が最新の caseToken を
  // 参照できるよう、レンダー時点で同期的に反映する (useEffect だと反映が 1 tick 遅れレースになる)。
  // AppLayout はルーター上ですべてのページの親として常駐し実質アンマウントされないため、
  // アンマウント時のクリアは行わない (StrictMode の effect 二重実行時にクリアだけが実行され
  // 再レンダーなしにトークンが失われてしまうため)。
  setCaseToken(caseToken);

  return (
    <Box
      sx={{ minHeight: "100vh", bgcolor: colors.pageBg, display: "flex", flexDirection: "column" }}
    >
      <Header />
      <Box
        component="main"
        className="guest-main"
        sx={{ flex: 1, display: "flex", flexDirection: "column" }}
      >
        <Suspense fallback={<RouteFallback />}>
          <Outlet />
        </Suspense>
      </Box>
      <Footer />
    </Box>
  );
}
